import { AppBar, Box, Button, Menu, MenuItem, Tab, Tabs } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import { ChangeEvent, useState } from "react";
import { isUserInRole } from "../security/UserRoles";

export const enum ApplicationTab {
  Customers = 'customers',
  Materials = 'materials',
  SpringsMaterials = 'spring-matrials',
  PricingGroups = 'pricing-groups',
  Pricing = 'pricing',
  Forms = 'forms',
  Shapes = 'shapes',
  Kits = 'kits',
  BonnellSprings = 'bonnell-springs',
  PocketSprings = 'pocket-springs',
  Orders = 'orders'
}

interface Props {
  selectedTab: ApplicationTab;
  onTabChange: (tabId: ApplicationTab) => void;
  customerSelected: boolean;
}

const HorizontalNavigation = (props: Props) => {
  const { keycloak } = useKeycloak();
  const customerSelected = props.customerSelected;
  const selectedTab = props.selectedTab;
  const [foamTabsVisible, setFoamTabsVisible] = useState<boolean>(false);
  const [springTabsVisible, setSpringTabsVisible] = useState<boolean>(false);
  const [accountMenuAnchorElement, setAccountMenuAnchorElement] = useState<null|HTMLElement>(null);
  const isAccountMenuOpen = accountMenuAnchorElement !== null;

  const logout = () => {
    keycloak.logout();
  };

  const handleTabChange = (event: ChangeEvent<{}>, applicationTab: ApplicationTab) => {
    props.onTabChange(applicationTab);
  };

  const handleFoamTabClick = (event: React.MouseEvent<HTMLElement>) => {
    if (customerSelected === true && (!foamTabsVisible || selectedTab === ApplicationTab.Materials)) {
      setFoamTabsVisible(!foamTabsVisible);
    }
    setSpringTabsVisible(false);
  };

  const handleSpringTabClick = (event: React.MouseEvent<HTMLElement>) => {
    if (customerSelected === true && (!springTabsVisible || selectedTab === ApplicationTab.SpringsMaterials)) {
      setSpringTabsVisible(!springTabsVisible);
    }
    setFoamTabsVisible(false);
  };

  const getFoamLabel = () => {
    if (foamTabsVisible) {
      return selectedTab === ApplicationTab.Materials ? '... Pianki' : 'Pianki';
    } else {
      return customerSelected ? 'Pianki ...' : 'Pianki';
    }
  };

  const getSpringMaterialLabel = () => {
    if (springTabsVisible) {
      return selectedTab === ApplicationTab.SpringsMaterials ? '... Sprężyny' : 'Sprężyny';
    } else {
      return customerSelected ? 'Sprężyny ...' : 'Sprężyny';
    }
  };

  const handleAccountButtonClicked = (event: React.MouseEvent<HTMLElement>) => setAccountMenuAnchorElement(event.currentTarget);

  const closeAccountMenu = () => setAccountMenuAnchorElement(null);

  const removeQuotes = (value: string) => value.replace('"', '');

  return (
    <AppBar position="static">
      <Tabs
          value={props.selectedTab}
          onChange={handleTabChange}>
        { isUserInRole(keycloak, 'CUSTOMERS_READ') &&
          <Tab label='Klienci' value={ApplicationTab.Customers} />
        }
        { isUserInRole(keycloak, 'ORDERS_READ') &&
          <Tab label='Zamówienia' value={ApplicationTab.Orders} />
        }
        { isUserInRole(keycloak, 'PRICELISTS_READ') &&
          <Tab label='Cennik' value={ApplicationTab.Pricing} />
        }
        { isUserInRole(keycloak, 'FOAMS_READ') &&
        <Tab
          label={ getFoamLabel() }
          value={ ApplicationTab.Materials }
          onClick={ handleFoamTabClick }/>
        }
        { foamTabsVisible && isUserInRole(keycloak, 'FOAMS_READ') &&
          <Tab label='Grupy cenowe' value={ApplicationTab.PricingGroups} />
        }
        { foamTabsVisible && customerSelected && isUserInRole(keycloak, 'FOAMS_READ') &&
          <Tab label='Formatki' value={ ApplicationTab.Forms } />
        }
        { foamTabsVisible && customerSelected && isUserInRole(keycloak, 'FOAMS_READ') &&
          <Tab label='Wykroje' value={ApplicationTab.Shapes} />
        }
        { foamTabsVisible && customerSelected && isUserInRole(keycloak, 'FOAMS_READ') &&
          <Tab label='Komplety' value={ApplicationTab.Kits}/>
        }
        { isUserInRole(keycloak, 'SPRINGS_READ') &&
          <Tab
            label={ getSpringMaterialLabel() }
            value={ ApplicationTab.SpringsMaterials }
            onClick={ handleSpringTabClick } />
        }
        { springTabsVisible && customerSelected && isUserInRole(keycloak, 'SPRINGS_READ') &&
          <Tab label='Bonnell' value={ApplicationTab.BonnellSprings}/>
        }
        { springTabsVisible && customerSelected && isUserInRole(keycloak, 'SPRINGS_READ') &&
          <Tab label='Pocket' value={ApplicationTab.PocketSprings}/>
        }
        <Box flexGrow={1} />
        { keycloak.token !== undefined &&
          <Button style={ { color: 'white', paddingRight: 20 } } onClick={ handleAccountButtonClicked }>
            { removeQuotes(keycloak.tokenParsed?.name) }
          </Button>
        }
        <Menu open={isAccountMenuOpen} anchorEl={accountMenuAnchorElement} onClose={ closeAccountMenu }>
          <MenuItem onClick={ logout }>
            <Button color='primary' variant='contained'>Wyloguj</Button>
          </MenuItem>
        </Menu>
      </Tabs>
    </AppBar>
  );
};
export default HorizontalNavigation;